var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-page-wrapper fc-container fc-padding-5 md:fc-padding-8 lg:fc-padding-10"},[_c('LazyHydrate',{attrs:{"never":""}},[_c('div',{staticClass:"legal-page-wrapper__content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }